import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
    selector: 'options-supp-modal',
    templateUrl: 'options-supp-modal.component.html',
    styleUrls: ['options-supp-modal.component.scss']
})
export class OptionsSuppModalComponent {
    options: any = [];
    bouncIn = false;
    constructor(
        public bsModalRef: BsModalRef,
    ) {
        setTimeout(
            () => {
                this.options[0].checked = true;
                this.bouncIn = true;
                setTimeout(
                    () => {
                        this.options[0].checked = false;
                        this.bouncIn = false;
                    }, 500
                )
            }, 500
        )
    }
    valider() {
        this.bsModalRef.hide();
    }
}
